import React, { useState, useEffect, useContext } from 'react';
import BrowseLayout from '../components/home/BrowseLayout';
import ListingsGrid from '../components/home/ListingsGrid';
import { LoadingContext } from '../App';
import { sortListingsByRarity } from '../utils/sortListings';

const PromoListingsPage = () => {
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const { setLoading: setGlobalLoading } = useContext(LoadingContext);

    useEffect(() => {
        const fetchListings = async () => {
            setLoading(true);
            setGlobalLoading(true);
            try {
                const response = await fetch(`${apiBaseUrl}/listings?isPromo=1&count=500`);
                if (!response.ok) throw new Error('Failed to fetch listings');
                const data = await response.json();
                setListings(data.status === 'success' && Array.isArray(data.listings) ? sortListingsByRarity(data.listings) : []);
            } catch (err) {
                setError('Failed to load listings. Please try again later.');
                setListings([]);
            } finally {
                setLoading(false);
                setGlobalLoading(false);
            }
        };
        fetchListings();
    }, [apiBaseUrl, setGlobalLoading]);

    return (
        <BrowseLayout>
            <ListingsGrid
                title="Promos"
                subtitle={error ? null : `${listings.length} card${listings.length === 1 ? '' : 's'}`}
                listings={listings}
                loading={loading}
                error={error}
            />
        </BrowseLayout>
    );
};

export default PromoListingsPage;
